module.exports = __webpack_public_path__ + "static/media/football_equipment_image.92213c45.jpg";